export const messages = Object.freeze({
    'API key is invalid': 'Your API key is invalid.',
    api_key_deleted: 'The API key has been deleted.',
    api_key_missing: 'The API key is missing or could not be found.',
    "Authorization header must be 'basic &lt;token&gt;'": 'Invalid API key format.',
    no_api_key_found: 'No API key was found.'
})

export const dialogs = Object.freeze({})
